<div class="overflow-auto p-5" style="height: 75vh">
  <h1 class="text-chathams-blue font-bold text-xl leading-5 tracking-tight mb-3">
    Adicionar motivo de atendimento para a empresa
  </h1>
  <form (ngSubmit)="addReasonToCompany()" [formGroup]="formGroup">
    <ng-select
      notFoundText="Nenhum item encontrado"
      [items]="reasonOptions"
      placeholder="Motivos de Atendimento"
      formControlName="reasonSelected"
      bindLabel="description"
      bindValue="id"
      [multiple]="true"
    >
    </ng-select>

    <h1 class="text-chathams-blue font-bold text-xl leading-5 tracking-tight my-3">
      Adicionar motivo de cancelamento para a empresa
    </h1>

    <ng-select
      notFoundText="Nenhum item encontrado"
      [items]="cancellationReasonsOptions"
      placeholder="Motivos de Atendimento"
      formControlName="cancellationReasonsSelected"
      bindLabel="description"
      bindValue="id"
      [multiple]="true"
    >
    </ng-select>

    <div class="flex items-center justify-center m-4">
      <button class="w-80 btn btn--secondary mr-5" type="submit">Atualizar Motivo</button>
    </div>
  </form>
</div>
